module.exports = __webpack_public_path__ + "img/Logo Pernambucanas.5143d4e3.svg";